import React from "react";

export default function Rainbow() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="77" height="4" viewBox="0 0 77 4">
			<g id="Group_680" data-name="Group 680" transform="translate(-299 -358)">
				<rect id="Rectangle_794" data-name="Rectangle 794" width="15" height="4" transform="translate(299 358)" fill="#32a8a4" />
				<rect id="Rectangle_795" data-name="Rectangle 795" width="16" height="4" transform="translate(314 358)" fill="#db6048" />
				<rect id="Rectangle_796" data-name="Rectangle 796" width="15" height="4" transform="translate(330 358)" fill="#2d6fa7" />
				<rect id="Rectangle_797" data-name="Rectangle 797" width="15" height="4" transform="translate(345 358)" fill="#d7a44d" />
				<rect id="Rectangle_798" data-name="Rectangle 798" width="16" height="4" transform="translate(360 358)" fill="#64548a" />
			</g>
		</svg>
	);
}
